<template>
  <div class="page VR"  v-wechat-title="$route.meta.title">
    <img class="vr-bj" src="../../assets/vr1.jpg" alt="">

    <!--新增全景视频模块-->
    <div class="video-vr border-box">
      <div class="video-vr-con" v-for="(item,index) in root">
        <div class="video-vr-top" @click="goVideoVR(item.id)">
          <span class="video-vr-mask"></span>
          <img class="icon_360" src="../../assets/icon_360.png" alt="" v-if="citySite!=1&&citySite!=''">
          <div class="video-vr-img" id="video-vr-img" v-if="citySite==''&&index==0"></div>
          <img class="video-vr-img" v-lazy="item.tvideourl" alt="" v-else>
          <img class="video-vr-btn pause" src="../../assets/view-video-bf.png" alt="" v-if="citySite!=''">
          <div class="video-tit border-box hide" v-if="citySite!=''">{{item.name}}</div>
          <span class="video-vr-txt num" v-if="citySite!=''">{{item.listencount|initNumber}}次播放</span>
          <span class="video-vr-txt spot" v-if="citySite!=1&&citySite!=''">{{item.spotNum}}个景点</span>
        </div>
        <div class="video-vr-bot border-box">
          <img class="fl video-vr-guide" v-lazy="item.headimg" alt="" v-if="citySite!=''">
          <span class="fl video-vr-name hide" v-if="citySite!=''">{{item.fname}}</span>
          <span class="fl video-vr-tag video-vr-tag1" v-if="citySite==''&&index==0">推荐</span>
          <span class="fl video-vr-tag" v-if="citySite==''&&index==1">热门</span>
          <span class="fl video-vr-name hide" v-if="citySite==''">{{item.name}}</span>
          <button class="fr btn buy-btn" @click="goVideoVR(item.id)" v-if="item.isbuy>0 || item.price<=0">{{citySite==''?'去观看':'观看'}}</button>
          <button class="fr btn buy-btn" @click="buyVideoVr(item.id)" v-else>{{citySite==''?'去体验':'购买'}}</button>
        </div>
      </div>

      <div class="video-vr-con" v-for="(item,index) in linkList">
        <div class="video-vr-top" @click="goOutLink(item.link)">
          <span class="video-vr-mask"></span>
          <img class="video-vr-img" v-lazy="item.img" alt="">
        </div>
        <div class="video-vr-bot border-box">
          <span class="fl video-vr-name hide">{{item.name}}</span>
          <button class="fr btn buy-btn">去观看</button>
        </div>
      </div>
    </div>
    <p class="load-tip" ref="loadtip" style="display: none">{{loadText}}</p>

  </div>

</template>

<script>

  import {getViewDetail, getBagTab, getCatalogue, uploadScan, getEnvelope, getUserTui, uploadUserBrowse, getNotice,getViewVr,citySiteVR,siteVrlist } from "@/service/getData";
  import {wxGetPosition,getCityInfo,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        siteid: this.$route.query.siteid || '',//站点id
        sregion: this.$route.query.sregion || '',//省站点id:430000
        shopid: this.$route.query.shopid || '', //景区id
        spotid: this.$route.query.spotid || '', //景点id
        userInfo: {}, //用户信息
        page: 1,
        rows: 7,
        loadText: "数据加载中",
        latlng: {lat: '', lng: ''}, //经纬度信息
        cityInfo: { citycode: '650000'||"1", city: "全部", address: "" },
        citySite: this.$route.query.citySite || '',//是否为城市站点首页跳过来 1：是  3,语音包跳过来的
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        code: '650000' || '',//城市站点code或者home页面的citycode
        root:[],//VR视频列表
        total: '',//VR视频专辑总数

        linkList: [
          {
            id: 1,
            name: '新疆维吾尔自治区博物馆',
            link: 'https://720yun.com/t/fdvkuw8mspe?scene_id=39744304',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj1.jpg'
          },
          {
            id: 2,
            name: '巴里坤大河唐城',
            link: 'http://vr.xjdft.cn/tour/a0947dc41fc614e2',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj2.jpg'
          },
          {
            id: 3,
            name: '哈密市博物馆',
            link: 'http://vr.xjdft.cn/tour/d2b520ac40cae116',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj3.jpg'
          },
          {
            id: 4,
            name: '吐鲁番博物馆',
            link: 'https://720yun.com/t/1bvknw7ed2h?scene_id=30313506',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj4.jpg'
          },
          {
            id: 5,
            name: '新疆若羌楼兰博物馆',
            link: 'https://720yun.com/t/3bfjr0kOzO8?scene_id=26374521',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj5.jpg'
          },
          {
            id: 6,
            name: '木垒县博物馆',
            link: 'https://720yun.com/t/3cajvzwkkn7?scene_id=20178383',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj6.jpg'
          },
          {
            id: 7,
            name: '新疆兵团军垦博物馆',
            link: 'https://720yun.com/t/3cvkn92br2w?scene_id=29606015',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj7.jpg'
          },
          {
            id: 8,
            name: '三五九旅屯垦纪念馆',
            link: 'https://720yun.com/t/68vkcyil07y?scene_id=62753832',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj8.jpg'
          },
          {
            id: 9,
            name: '五家渠将军纪念馆',
            link: 'https://720yun.com/t/783jeOwmsy5?scene_id=17636531',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj9.jpg'
          },
          {
            id: 10,
            name: '哈密烽燧',
            link: 'http://vr.xjdft.cn/tour/40acf50b7d0e0658',
            img: 'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xj10.jpg'
          },
        ], //720全景链接
      }
    },
    computed: {

    },
    created(){

      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      let self = this;
      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = { citycode: "1", city: "全国", address: "" };
          setStore("cityInfo",self.cityInfo);
          self.initData(self.page);
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData(self.page);
        });
      }

      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(page){
        let res;
        if(this.citySite == 2){
          this.$route.meta.title = '全景视频';
          res = await citySiteVR({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            citySite:this.citySite,
            type:1,
            code:this.code,
            page: page,
            rows: this.rows
          });
        }else if(this.citySite == 1){
          this.$route.meta.title = '视频列表';
          res = await citySiteVR({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            citySite:this.citySite,
            type:0,
            code:this.code,
            page: page,
            rows: this.rows
          });
        }else if(this.citySite == 3){
          this.$route.meta.title = '视频列表';
          res = await siteVrlist({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            id: this.shopid,
            page: page,
            rows: this.rows
          });
        }else{
          this.$route.meta.title = '云游新疆过大年';
          res = await getViewVr({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            shopid: this.shopid,
            spotid: this.spotid || '',
            code: this.code || '1',
            lat: this.latlng.lat || '',
            lng: this.latlng.lng || '',
            siteid: this.siteid,
            sregion: this.sregion,
            page: page,
            rows: this.rows
          });
        }

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.root || [];
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title ='云游新疆过大年--720VR全景文博馆';
          let desc = '新疆是的好地方，游新疆邀您云游新疆文博场馆，看全景，听故事。';
          let link = "/video-vrlist-xj";
          wxShareme(title,desc,"https://filewc.geeker.com.cn/jpFile/scenic/images/xj/xjvrlogo.jpg",link);

        }else {
          this.$toast(res.errmsg)
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //点击购买，调用下订单公用方法
      buyVideoVr(id){
        let self = this;
        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});

        if(this.citySite == 1){
          self.$router.push({
            path: `/pay?${'pid='+id+'&cid=&shopid=&bagtype=1'+'&appKey='+(self.appKey)}`
          });
        }else if(this.citySite == 2){
          self.$router.push({
            path: `/pay?${'pid='+id+'&cid=&shopid=&bagtype=2'+'&appKey='+(self.appKey)}`
          });
        }else{
          self.$router.push({
            path: `/pay?${'pid='+id+'&cid=&shopid='+self.shopid+'&bagtype=2'+'&appKey='+(self.appKey)}`
          });
        }
      },

      //跳转到VR视频
      goVideoVR(id){
        if(this.citySite == 1){
          this.$router.push({
            path: `/video-play1?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=1'}`
          });
        }else if(this.citySite == 2){
          this.$router.push({
            path: `/video-vr?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }else{
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }
      },

      goOutLink(link){
        window.location = link
      },

      showPhotoVR(imgurl,obj){
//            var imgurl = require('../../assets/qj.jpg');
        var self = this;
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false,  //不显示下面的导航栏
          overload: function(){
            self.loadPSV = true;
          }
        });
      },

    },
    watch:  {
      root(){
        var self = this;
        this.$nextTick(function(){
          if(self.root[0]&&self.root[0].vrimg && self.root[0].vrimg != '' && self.root[0].vrimg != null && self.citySite==""){
            self.showPhotoVR(self.root[0].vrimg,'video-vr-img');
          }
        })
      },
    },
    components: {},
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";

  .page{ padding-bottom: .2rem; }

  /*全景视频*/
  .video-vr{padding: 0 .26rem .4rem;}
  .video-vr-con{ padding-top: .24rem; width: 100%;height: 3.98rem;border-radius: .1rem;box-shadow: 0 0 .25rem #f7f7f7;overflow: hidden;}
  .video-vr-tit{width:100%;height: .96rem;font: bold .28rem/1.03rem "Microsoft YaHei";color: #3d3d3d;overflow: hidden;}
  .video-vr-tit .fr{font:normal .24rem/1.03rem "Microsoft YaHei";color: #555;}
  .video-vr-top{ display: block; position:relative;width: 100%;height: 3rem;border-radius: .1rem .1rem 0 0;overflow: hidden;}
  .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .1rem .1rem 0 0;object-fit: cover;}
  .video-vr-mask{position: absolute;z-index: 1;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.3);}
  .video-vr .icon_360{position: absolute;z-index: 1;top:.12rem;right:.12rem;width: 1.36rem;height: auto;}
  .video-vr .video-tit{position: relative;z-index: 1;width:100%;height:.75rem;padding: 0 1.6rem 0 .2rem;font: .26rem/.75rem "Microsoft YaHei";color: #fff;}
  .video-vr-btn{position: absolute;z-index:1;top:50%;left:50%;width: 1.02rem;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .video-vr-txt{position: absolute;z-index: 1;bottom: .14rem;font: bold .2rem "Microsoft YaHei";color: #fff;}
  .video-vr-txt.num{ left:.2rem;}
  .video-vr-txt.spot{ right:.2rem;}
  .video-vr-bot{position:relative;width:100%;height: .98rem;padding: 0 .2rem;}
  .video-vr-guide{width: .58rem;height: .58rem;margin-top:.2rem;border-radius: 50%;object-fit: cover;}
  .video-vr-name{max-width:70%;margin-left: .15rem;font: .26rem/.98rem "Microsoft YaHei";color: #000;}
  .video-vr-bot .buy-btn{top: 50%;transform: translateY(-50%);}

  /*2020.12.29 新样式*/
  .page.VR{ position: relative; background-color: #ed710e; }
  .page.VR .vr-bj{ position: relative; width: 100%; height: auto; }
  .page.VR .video-vr{ padding: 0 .3rem .4rem; margin-top: -3.7rem; }
  .page.VR .video-vr-con{ height: auto; border-radius: .2rem;box-shadow: none; }
  .page.VR .video-vr-top{ height: 3.6rem;border-radius: .2rem .2rem 0 0; }
  .page.VR .video-vr-img{border-radius: .2rem .2rem 0 0; overflow: hidden; }
  .page.VR .video-vr-mask{ background: rgba(0,0,0,.2); }

  .page.VR .video-vr-bot{height: 1.04rem; padding: 0 .24rem; background: #fff;}
  .page.VR .video-vr-name{ font-size: .34rem; line-height: 1rem; color: #333; }
  .page.VR .video-vr-tag{ margin-top: .34rem; width: .68rem; height: .32rem; font-size: .2rem; line-height: .3rem; color: #fff; text-align: center; background: url(../../assets/vr-1.png) no-repeat center; background-size: 100% 100%; }
  .page.VR .video-vr-tag1{ background: url(../../assets/vr-3.png) no-repeat center; background-size: 100% 100%; }
  .page.VR .buy-btn{ padding: 0; right: .24rem; top: .24rem;transform: translateY(0); width: 1.38rem; height: .56rem;line-height: .54rem;font-size: .28rem; color: #e1390c; letter-spacing: .02rem;background: #ffe5cf; }
</style>
<style>
  .page.VR .psv-container{ position: absolute; padding: 1px; left:-1px; top:-1px; right:-1px; bottom:-1px; }
</style>



// WEBPACK FOOTER //
// src/page/video-vrlist/video-vrlist-xj.vue